import {
  SafeAreaView,
  VStack,
  ScrollView,
  Divider,
  View
} from "@gluestack-ui/themed";
import { CustomHeader } from "@repo/core/components/layout/CustomHeader";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { LimitsReceiptController } from "./controller";
import { StoreInfoSection } from "@repo/core/components/receipt/sections/StoreInfoSection";
import { Button } from "@repo/core/components/core/Button";
import { LimitsAvailableSection } from "@repo/core/components/receipt/sections/LimitsAvailableSection";
import { ClientInfoSection } from "@repo/core/components/receipt/sections/ClientInfoSection";
import { ShareButton } from "@repo/core/components/core/ShareButton";

const LimitsReceipt = () => {
  const {
    back,
    isMobile,
    handleGoToSales,
    limitsInfo,
    clientInfo,
    storeInfo,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading
  } = LimitsReceiptController();
  return (
    <VStack flex={1} bg="$backgroundLight0" height="$100vh" overflow="hidden">
      <StatusBar barStyle="light-content" showCustomStatusBar />
      <SafeAreaView flex={1}>
        <VStack px="$6" py="$2" mb={isMobile ? "$0" : "$4"}>
          <CustomHeader
            title="Consulta Limites Disponíveis"
            onBackPress={back}
            rightIcon="times"
            rightIconSize={20}
            rightWebLabel="Fechar"
            onPressRightIcon={handleGoToSales}
          />
        </VStack>
        <VStack flex={1} w="$full" h="$full" alignItems="center">
          <VStack
            justifyContent="flex-start"
            flex={1}
            $md-w="52%"
            $base-w="$full"
          >
            <ScrollView showsVerticalScrollIndicator={false}>
              <View flex={1} ref={viewRef} collapsable={false}>
                <VStack px="$6">
                  <LimitsAvailableSection {...limitsInfo} />
                </VStack>
                <Divider />
                <VStack px="$6">
                  <ClientInfoSection {...clientInfo} />
                </VStack>
                <Divider />
                <VStack px="$6">
                  <StoreInfoSection {...storeInfo} />
                </VStack>
              </View>
            </ScrollView>
          </VStack>
          <VStack
            $md-w="52%"
            $base-w="$full"
            pt={isMobile ? "$4" : "$12"}
            px={isMobile ? "$6" : "$0"}
            pb="$4"
            gap={16}
            justifyContent="flex-end"
            flexDirection={!isMobile ? "row-reverse" : "column"}
          >
            <Button
              flex={!isMobile ? 1 : undefined}
              text="Finalizar"
              action="positive"
              onPress={handleGoToSales}
            />
            <ShareButton
              flex={!isMobile ? 1 : undefined}
              isLoading={isLoading}
              onPress={handleCaptureAndGeneratePDF}
            />
          </VStack>
        </VStack>
      </SafeAreaView>
    </VStack>
  );
};
export default LimitsReceipt;
